import contextualSelect from './lib/contextual-select';

const importCommon = (requireFunction) => requireFunction.keys().forEach(requireFunction);
importCommon(require.context('./common', false, /\.js$/, 'sync'));

const importModules = (requireFunction) => requireFunction.keys().map(requireFunction);
const modules = importModules(require.context('./modules/', true, /\.js$/, 'sync'));
modules.forEach(({ moduleSelector, moduleCallBack }) => {
    const moduleElements = [...document.querySelectorAll(moduleSelector)];
    if (moduleElements.length > 0) {
        moduleElements.forEach((moduleElement) => {
            const query = (selector) => moduleElement.querySelector(selector);
            const queryAll = contextualSelect(moduleElement);
            moduleCallBack(moduleElement, query, queryAll);
        });
    }
});

const importSections = (requireFunction) => requireFunction.keys().map(requireFunction);
const sections = importSections(require.context('./sections/', true, /\.js$/, 'sync'));
sections.forEach(({ sectionSelector, sectionCallBack }) => {
    const sectionElements = [...document.querySelectorAll(sectionSelector)];
    if (sectionElements.length > 0) {
        sectionElements.forEach((sectionElement) => {
            const query = (selector) => sectionElement.querySelector(selector);
            const queryAll = contextualSelect(sectionElement);
            sectionCallBack(sectionElement, query, queryAll);
        });
    }
});
